import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/home/jenkins/workspace/prod/deploy-frontend/src/components/Footer/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FooterCopyright"] */ "/home/jenkins/workspace/prod/deploy-frontend/src/components/Footer/FooterCopyright.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FooterLegal"] */ "/home/jenkins/workspace/prod/deploy-frontend/src/components/Footer/FooterLegal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleTagManagerInitiator"] */ "/home/jenkins/workspace/prod/deploy-frontend/src/components/GoogleTagManagerInitiator/GoogleTagManagerInitiator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/home/jenkins/workspace/prod/deploy-frontend/src/components/Header/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CurrencyProvider","CurrencyContext"] */ "/home/jenkins/workspace/prod/deploy-frontend/src/contexts/CurrencyContext/CurrencyContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jenkins/workspace/prod/deploy-frontend/src/hocs/TranslationsProvider/TranslationsProvider.js");
